import { view } from '../view/view';
import { model } from '../model/model';
var signIn = function (result) {
    var successSignIn = model
        .signin({
        email: result[0],
        password: result[1],
    })
        .then(function (data) {
        if (!data) {
            view.renderUserMessageError();
            controllers.isUserSignIn = false;
        }
        else {
            controllers.updateUser();
            view.closeModalUserSign();
            controllers.isUserSignIn = true;
        }
    });
};
var signUp = function (result) {
    var successSignUp = model
        .signup({
        name: result[0],
        email: result[1],
        password: result[2],
    })
        .then(function (data) {
        if (!data) {
            view.renderUserMessageError('signin');
            controllers.isUserSignUp = false;
        }
        else {
            controllers.isUserSignUp = true;
            var user = result.slice(1);
            signIn(user);
        }
    });
};
var controllers = {
    signin: true,
    isUserSignIn: false,
    isUserSignUp: false,
    isSpinner: false,
    user: {},
    words: [],
    userWords: [],
    refreshToken: '',
    wordsGroup: '0',
    wordsPage: 1,
    init: function () {
        model.getPageLibrary();
        view.init();
        controllers.updateUser();
        if (controllers.wordsGroup === '6') {
            controllers.getDataWordsDifficult();
        }
        else {
            controllers.getDataWords();
        }
    },
    userSign: function (data) {
        if (data.length === 2)
            signIn(data);
        if (data.length === 3)
            signUp(data);
    },
    updateUser: function () {
        model.isSignIn();
        if (controllers.user) {
            controllers.isUserSignIn = true;
            view.renderUserLogin(controllers.user.name);
        }
        else {
            controllers.isUserSignIn = false;
            if (controllers.wordsGroup === '6') {
                controllers.wordsGroup = '0';
                controllers.wordsPage = 1;
            }
            view.renderUserLogin();
        }
    },
    getDataWords: function () {
        view.showSpinnerWords();
        model.savePageLibrary();
        if (controllers.isUserSignIn) {
            controllers.getDataUserWords();
        }
        else {
            var getWords = model.getWords()
                .then(function (data) {
                controllers.words = data;
                view.renderWordsDictionary();
            })
                .catch();
        }
    },
    getDataUserWords: function () {
        var getWords = model.getUserWords().then(function (data) {
            model
                .getWords()
                .then(function (data) {
                controllers.words = data;
                view.renderWordsDictionary();
            })
                .catch();
        });
    },
    getDataWordsDifficult: function () {
        view.showSpinnerWords();
        model.savePageLibrary();
        var getWords = model
            .getUserHardWords()
            .then(function (data) {
            controllers.words = data;
            view.renderWordsDictionary();
        })
            .catch();
    },
};
export { controllers };
